export default __webpack_public_path__ + "static/media/catg-img.35715592.png";